const Acknowledgments = () => {
    const acknowledgments = [
        {
            company: "AT&T",
            description: "Q4-13 Top 10 Hall of Fame",
            year: "2013 ",
            link: "https://web.archive.org/web/20140725233645/https://bugbounty.att.com/hof.php",
            logo: "/assets/logos/att.png"
        },
        {
            company: "Deutsche Telekom",
            description: "Security acknowledgment for multiple responsible disclosure",
            year: "2015",
            link: "https://www.telekom.com/en/company/data-privacy-and-security/news/acknowledgements-358300",
            logo: "/assets/logos/dt.jpg"
        },
        {
            company: "Barracuda Networks",
            description: "Vulnerability disclosure acknowledgment",
            year: "2014",
            logo: "/assets/logos/barracuda.webp",
            noLink: true
        },
        {
            company: "Nokia",
            description: "Security vulnerability acknowledgment",
            year: "2012",
            logo: "/assets/logos/nokia.png",
            noLink: true
        },
        {
            company: "Adobe",
            description: "Security acknowledgment",
            year: "2016",
            logo: "/assets/logos/adobe.png",
            noLink: true
        },

    ];

    return (
        <section id="acknowledgments" className="py-20 bg-gray-50 dark:bg-gray-800">
            <div className="container mx-auto px-4 sm:px-6 lg:px-8">
                <div className="text-center mb-16">
                    <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 dark:text-white mb-4">Past Acknowledgments</h2>
                    <div className="w-24 h-1 bg-blue-600 mx-auto rounded"></div>
                    <p className="mt-6 text-lg text-gray-600 dark:text-gray-400 max-w-2xl mx-auto">
                        Recognition for security research and responsible disclosures (2013-2016)
                    </p>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                    {acknowledgments.map((ack, index) => (
                        <a
                            key={index}
                            href={ack.link}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="bg-white dark:bg-gray-700 rounded-lg shadow-md hover:shadow-xl transition-shadow p-6 flex flex-col items-center"
                        >
                            <div className="h-16 w-full flex items-center justify-center mb-4">
                                <img
                                    src={ack.logo || "https://via.placeholder.com/150x60?text=Logo"}
                                    alt={`${ack.company} logo`}
                                    className="max-h-full max-w-full object-contain"
                                />
                            </div>
                            <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-2">{ack.company}</h3>
                            <p className="text-gray-600 dark:text-gray-300 text-center mb-2">{ack.description}</p>
                            <span className="text-sm text-blue-600 dark:text-blue-400 font-medium">{ack.year}</span>
                        </a>
                    ))}
                </div>

                <div className="mt-12 text-center">
                    <p className="text-gray-600 dark:text-gray-400">
                        These acknowledgments represent early security research work. For more recent contributions, please check my projects and GitHub repositories.
                    </p>
                </div>
            </div>
        </section>
    );
};

export default Acknowledgments;